<template>
    <div :class="{ 'is-up': renderUp }" class="dropdown is-active">
        <div class="dropdown-menu" role="menu">
            <div v-if="loading" class="loader" />
            <div v-else class="dropdown-content">
                <div
                    v-for="(item, index) in items"
                    :key="index"
                    :class="{ 'is-selected': index === selectedIndex }"
                    class="dropdown-item"
                    @click="selectItem(index)"
                >
                    <p>{{ item.username }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        items: {
            type: Array,
            default() {
                return [];
            },
        },
        command: {
            type: Function,
            default() {},
        },
        loading: {
            type: Boolean,
            default: true,
        },
        renderUp: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            selectedIndex: 0,
        };
    },
    watch: {
        items() {
            this.selectedIndex = 0;
        },
    },
    methods: {
        onKeyDown({ event }) {
            if (event.key === 'ArrowUp') {
                this.upHandler();
                return true;
            }
            if (event.key === 'ArrowDown') {
                this.downHandler();
                return true;
            }
            if (event.key === 'Enter') {
                this.enterHandler();
                return true;
            }
            return false;
        },
        upHandler() {
            this.selectedIndex =
                (this.selectedIndex + this.items.length - 1) %
                this.items.length;
        },
        downHandler() {
            this.selectedIndex = (this.selectedIndex + 1) % this.items.length;
        },
        enterHandler() {
            this.selectItem(this.selectedIndex);
        },
        selectItem(index) {
            const item = this.items[index];
            if (item) {
                this.command({ id: item.username });
            }
            this.$emit('select', item);
        },
    },
};
</script>

<style></style>
